import styled from 'styled-components';

import { Locale } from 'modules/domains/template';
import { colors, fontSizes, spacing } from 'ui/theme';

import { useTranslations } from '../../hooks/useTranslations';
import { LocaleLabel } from '../LocaleLabel/LocaleLabel';

const StyledLabelWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  justify-content: center;
  line-height: ${fontSizes.s11};
`;

const StyledLabel = styled.span`
  padding-right: ${spacing.threeEights};
  color: inherit;
`;

const StyledDefault = styled.span`
  color: ${colors.grey60};
  padding-right: ${spacing.threeEights};
`;

export const testIdsLocaleLabelText = {
  label: `locale-label-container-text`,
  labelDefault: `locale-label-text-default`,
  labelText: `locale-label-text-text`,
};

type LocaleLabelTextProps = {
  isDefault: boolean;
  locale: Locale;
};

export const LocaleLabelText = ({ isDefault = false, locale }: LocaleLabelTextProps) => {
  const { t } = useTranslations();
  return (
    <StyledLabelWrapper data-test={testIdsLocaleLabelText.label}>
      <StyledLabel data-test={testIdsLocaleLabelText.labelText}>
        <LocaleLabel locale={locale} />
      </StyledLabel>
      {isDefault && (
        <StyledDefault data-test={testIdsLocaleLabelText.labelDefault}>
          {t('label.default')}
        </StyledDefault>
      )}
    </StyledLabelWrapper>
  );
};
